import { render } from "./confirm-accept.vue?vue&type=template&id=fa607c46"
import script from "./confirm-accept.vue?vue&type=script&lang=js"
export * from "./confirm-accept.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__